import { render, staticRenderFns } from "./AsMaster.vue?vue&type=template&id=2660aee6&scoped=true"
import script from "./AsMaster.vue?vue&type=script&lang=js"
export * from "./AsMaster.vue?vue&type=script&lang=js"
import style0 from "./AsMaster.vue?vue&type=style&index=0&id=2660aee6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2660aee6",
  null
  
)

export default component.exports